export const LOTTIE_PLAYER_VERSION = "2.0.4";
export const LOTTIE_WEB_VERSION = "^5.12.2";
